// src/services/categories.service.js
import { http } from "./http";

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Helper: construye el payload esperado por la API.
 * La API espera: { id?, name, parent } donde parent es un string (id del padre) o null.
 * Permitimos pasar { parentId } o { parent } desde el caller.
 */
function buildPayload({ id, name, parent, parentId }) {
  return {
    ...(id ? { id } : {}),
    name,
    parent: typeof parentId !== "undefined" ? parentId : parent ?? null,
  };
}

/** Get the list of Categories and SubCategories */
export async function listCategories() {
  const { data } = await http.get(`${API_URL}/api/categories`);
  return data;
}

/** Get one Category or SubCategory */
export async function getCategory(id) {
  const { data } = await http.get(`${API_URL}/api/categories/${id}`);
  return data;
}

/** Add a Category or SubCategory */
export async function createCategory(dto) {
  const payload = buildPayload(dto);
  const { data } = await http.post(`${API_URL}/api/categories`, payload);
  return data;
}

/** Update a Category or SubCategory */
export async function updateCategory(id, dto) {
  const payload = buildPayload({ id, ...dto });
  const { data } = await http.put(`${API_URL}/api/categories/${id}`, payload);
  return data;
}

/** Delete a Category or SubCategory */
export async function deleteCategory(id) {
  const { data } = await http.delete(`${API_URL}/api/categories/${id}`);
  return data;
}

/** Get the list of only Categories */
export async function listOnlyCategories() {
  const { data } = await http.get(`${API_URL}/api/categories/categories`);
  return data;
}

/** Get the list of Subcategories by Category */
export async function listSubcategoriesByCategory(categoryId) {
  const { data } = await http.get(`${API_URL}/api/categories/by-category/${categoryId}`);
  return data;
}

